import React from 'react';
import './success-modal.scss';
import { SwipeableDrawer } from '@mui/material';
import { SVGS } from '../../assets';
import { CommonButton } from '../button';
import { dispatch, updateSelectedProducts } from '@zonofi/zono-money-store';
import { ReactComponent as ShareIcon } from '@zonofi/svg-icons/share.svg';

interface SuccessModalProps {
  open: boolean;
  message: string;
  description?: string;
  onShare?: () => void;
  showShareButton?: boolean;
  mainText?: string;
  onClose: () => void;
  onMainTextPress?: () => void;
}

export const SuccessModal: React.FC<SuccessModalProps> = ({
  open,
  message,
  description,
  onShare = () => {},
  showShareButton = true,
  mainText = 'Close',
  onClose,
  onMainTextPress = () => {},
}) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen={true}
      PaperProps={{
        className: 'success-modal__drawer-paper',
        role: 'dialog',
        'aria-label': 'Success Modal',
      }}
    >
      <div className="success-modal-container">
        <img
          src={SVGS.SuccesIcon}
          alt="Success icon"
          width={120}
          height={120}
        />
        <div className="success-modal-content">
          <div className="message font-semibold">{message}</div>
          {description && (
            <div className="description font-regular">{description}</div>
          )}
        </div>
      </div>

      <div className="success-modal-buttons">
        <CommonButton
          text={mainText}
          onPress={() => {
            onMainTextPress?.();
            onClose?.();
            dispatch(updateSelectedProducts([]));
          }}
        />

        {showShareButton && (
          <CommonButton
            text="Share"
            onPress={onShare}
            buttonStyle="share-btn"
            textStyle="share-btn"
            startIcon={<ShareIcon />}
          />
        )}
      </div>
    </SwipeableDrawer>
  );
};
